import { render, staticRenderFns } from "./Detection.vue?vue&type=template&id=cb815e8a&scoped=true&"
import script from "./Detection.vue?vue&type=script&lang=js&"
export * from "./Detection.vue?vue&type=script&lang=js&"
import style0 from "./Detection.vue?vue&type=style&index=0&id=cb815e8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb815e8a",
  null
  
)

export default component.exports